var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "l-bg-white" }, [
      _c("div", { staticClass: "row bg-grey pt-3" }, [
        _c("div", { staticClass: "col-12" }, [
          _c("h3", { staticClass: "title-h3 border-bottom pb-3" }, [
            _c("button", {
              staticClass: "btn btn-back",
              attrs: { type: "button" },
              on: {
                click: function($event) {
                  _vm.$router.push("/settings/claim-types")
                }
              }
            }),
            _vm._v("\n          Back\n        ")
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "form",
        {
          attrs: { autocomplete: "no" },
          on: {
            submit: function($event) {
              $event.preventDefault()
              return _vm.submit($event)
            },
            keydown: function($event) {
              _vm.clearError($event)
            }
          }
        },
        [
          _c("div", { staticClass: "row pt-3" }, [
            _c(
              "div",
              { staticClass: "col-3" },
              [
                _c("div", { staticClass: "select-wrap" }, [
                  _c("label", [_vm._v("Claim type name")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.claimType.name,
                        expression: "claimType.name"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: { type: "text" },
                    domProps: { value: _vm.claimType.name },
                    on: {
                      keyup: _vm.toggleEditedNameGroup,
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.claimType, "name", $event.target.value)
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c("error-field", {
                  attrs: { errors: _vm.errors, field: "name" }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row mx-0" }, [
            _c("div", { staticClass: "col py-3 pl-0 text-left" }, [
              _vm.$_can("claims.types.destroy")
                ? _c(
                    "button",
                    {
                      staticClass: "btn btn-delete",
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          _vm.deleteClaimType(_vm.claimType.id)
                        }
                      }
                    },
                    [_vm._v("\n            Delete\n          ")]
                  )
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col py-3 pr-0 text-right" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-secondary",
                  attrs: { type: "button", disabled: !_vm.buttonDisabled },
                  on: {
                    click: function($event) {
                      _vm.getClaimType(_vm.claimType.id)
                    }
                  }
                },
                [_vm._v("\n            Discard\n          ")]
              ),
              _vm._v(" "),
              _vm.$_can("claims.types.update")
                ? _c(
                    "button",
                    {
                      staticClass: "btn btn-primary ld-ext-right",
                      class: _vm.loadingButton ? "running" : "",
                      attrs: { disabled: !_vm.buttonDisabled }
                    },
                    [
                      _vm._v("\n            Save\n            "),
                      _c("div", { staticClass: "ld ld-ball ld-flip" })
                    ]
                  )
                : _vm._e()
            ])
          ])
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-00f28f63", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-00f28f63","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/ClaimTypes/SettingsEditClaimType.vue
// module id = null
// module chunks = 